import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import { IndustryInput } from 'industries-core/components/IndustryInput';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from '../signup-data/DATA';
import { getIndustryOtherOption } from '../step-industry/getIndustryOtherOption';
import { useIndustry } from '../step-industry/useIndustry';
import { updateTypeaheadSelectedValue, updateTypeaheadTrackedUserInput } from '../store/typeahead/action-creators';
import { ErrorMessage } from '../views-components/ErrorMessage';
import { InputStyles } from '../views-components/TextInput.styles';
import { TypeaheadFormControl } from '../views/Forms.styles';
export const IndustrySelect = () => {
  const {
    isMobile
  } = useResponsiveness();
  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch();
  const {
    selectedIndustryValue,
    selectedIndustryText,
    setIndustry,
    input
  } = useIndustry();
  const isInvalid = !selectedIndustryValue && Boolean(input);

  const onInputValueChange = value => {
    dispatch(updateTypeaheadTrackedUserInput(value, Data.Industry));

    if (selectedIndustryValue && !isMobile) {
      setIndustry('');
      dispatch(updateTypeaheadSelectedValue('', Data.Industry));
    }
  };

  const onSelectOptionChange = option => {
    setIndustry(option.value);
    dispatch(updateTypeaheadSelectedValue(option.text, Data.Industry));
  };

  const renderErrorMessage = useCallback(() => {
    if (isInvalid || hasError) {
      const errorMessageProps = {
        dataKey: Data.Industry
      };

      if (hasError) {
        errorMessageProps.explicitMessageKey = 'errorFetchingIndustries';
      }

      return /*#__PURE__*/_jsx(ErrorMessage, Object.assign({}, errorMessageProps));
    }

    return null;
  }, [isInvalid, hasError]);
  return /*#__PURE__*/_jsx(TypeaheadFormControl, {
    error: isInvalid,
    label: I18n.text(`data.${Data.Industry}.default.label`),
    validationMessage: renderErrorMessage(),
    children: /*#__PURE__*/_jsx(InputStyles, {
      disabled: hasError,
      error: isInvalid,
      industryStyle: true,
      success: Boolean(selectedIndustryValue),
      children: /*#__PURE__*/_jsx(IndustryInput, {
        autoFocus: false,
        disabled: hasError,
        focusTimeout: 400,
        illustrationCaption: `views.${Data.Industry}.typeToSearchIndustries`,
        illustrationName: 'companies',
        inputValue: !selectedIndustryText ? input : selectedIndustryText,
        isFullScreenOpen: false,
        isMobile: isMobile,
        label: I18n.text(`data.${Data.Industry}.label`),
        otherOption: getIndustryOtherOption(),
        shouldShowPlaceholder: false,
        shouldUseRelevantSearch: true,
        onFetchError: () => {
          setIndustry(null);
          setHasError(true);
        },
        onInputValueChange: onInputValueChange,
        onSelectedOptionChange: onSelectOptionChange
      })
    })
  });
};